var React = require('react');

function QuoteMarks (props) {
    return React.createElement("svg",props,React.createElement("text",{"style":{"fill":"#fff","fillRule":"evenodd","fontFamily":"Montserrat-Medium, Montserrat","fontSize":"50","fontWeight":"400","opacity":".748954"},"transform":"translate(-770 -35)"},React.createElement("tspan",{"x":"768","y":"73"},"“")));
}

QuoteMarks.defaultProps = {"height":"15","viewBox":"0 0 17 15","width":"17"};

module.exports = QuoteMarks;

QuoteMarks.default = QuoteMarks;
